module.exports = __webpack_public_path__ + "img/credit-score-monitoring-hero.3e7b88a0.jpg";